import PropTypes from "prop-types";

import { useDispatch } from "react-redux";

import Modal from "@shared/v2/Modal";
import Button from "@shared/v2/Button";

import { setPersonValue } from "../../reducers/contactsReducer";

const RemoveSubdomainModal = ({ show, onClose }) => {
  const dispatch = useDispatch();

  return (
    <Modal
      className="tw-flex tw-items-center tw-justify-center"
      contentClassName="tw-w-[616px] tw-flex tw-flex-col tw-gap-[32px]"
      show={show}
      onHide={onClose}
    >
      <Modal.Header className="tw-relative tw-text-gray-50" title="Remove Subdomain" closeButton />
      <Modal.Body className="tw-relative tw-flex tw-flex-col tw-gap-20px tw-overflow-hidden">
        <span>Are you sure you want to remove your subdomain?</span>
        <span>
          <b>Note:</b> It can take up to 30 minutes for your subdomain to be completely removed.
        </span>
      </Modal.Body>
      <Modal.Footer className="tw-flex tw-justify-between ">
        <Button schema="tertiary" size="medium" onClick={onClose}>
          CANCEl
        </Button>
        <Button
          size="medium"
          onClick={() => {
            dispatch(setPersonValue({ key: "loginUserAttributes.subdomain", value: null }));
            onClose();
          }}
          schema="warning"
        >
          YES, REMOVE
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RemoveSubdomainModal;

RemoveSubdomainModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

RemoveSubdomainModal.defaultProps = {
  show: false,
};
